<main class="seccion-contacto">
    <div class="contenedor">
        <div class="imagen-contacto"></div>
        
        <div class="formulario-contacto">
            <div class="circulo-azul-contacto"></div>
            <h2>Conversemos</h2>
            
            <form class="formulario" [formGroup]="contactoForm" (ngSubmit)="onSubmit()">
                <div class="campo-formulario">
                    <label for="nombre">Nombre completo*</label>
                    <input type="text" id="nombre" formControlName="nombre" placeholder="Tu nombre aquí" maxlength="255">
                </div>
                
                <div class="campos-linea">
                    <div class="campo-formulario">
                        <label for="email">Correo electrónico*</label>
                        <input type="email" id="email" formControlName="email" placeholder="ejemplo@correo.com" maxlength="255">
                    </div>
                    <div class="campo-formulario">
                        <label for="telefono">Teléfono*</label>
                        <input type="tel" id="telefono" formControlName="telefono" placeholder="999 999 999" maxlength="20">
                    </div>
                </div>
                
                <div class="campo-formulario">
                    <label for="empresa">Empresa / Institución <span class="opcional">(Opcional)</span></label>
                    <input type="text" id="empresa" formControlName="empresa" placeholder="Nombre de tu empresa o institución" maxlength="255">
                </div>
                
                <div class="campo-formulario">
                    <label>Ciudad / Departamento*</label>
                    
                    <select formControlName="ciudad" style="display:none;"></select>
                    
                    <div class="custom-select" id="customSelectCiudad">
                        <div class="custom-select-selected" (click)="toggleDropdown()">
                            {{ ciudadSeleccionadaLabel }}
                        </div>
                        
                        <div class="custom-select-options" *ngIf="dropdownOpen">
                            <div *ngFor="let ciudad of ciudades" 
                                 (click)="seleccionarCiudad(ciudad)"
                                 [class.selected]="contactoForm.get('ciudad')?.value === ciudad.value">
                                {{ ciudad.label }}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="campo-formulario">
                    <label for="mensaje">Detalle*</label>
                    <textarea id="mensaje" formControlName="detalle" placeholder="Escribe tu consulta" rows="4" maxlength="5000"></textarea>
                </div>
                
                <button type="submit" class="btn-enviar" [class.loading]="isLoading" [disabled]="isLoading">
                    <span class="btn-texto" *ngIf="!isLoading">Enviar solicitud</span>
                    </button>

            </form>
        </div>
    </div>
</main>